<template>
  <tr>
    <th>vCPU</th>
    <td>
      <template v-if="editableState">
        <OsTypeSelect
          input-name="vm[vcpu]"
          :options="vcpuOptions"
          :model-value="currentValue('vcpu', initialVcpu)"
          empty-label="Select vCPU"
          filter-placeholder="Filter vCPU values"
          @update:modelValue="emit('update:vcpu', $event)"
        />
      </template>
      <template v-else>
        <input name="vm[vcpu]" type="hidden" :value="initialVcpu">
        <button type="button" class="form-control vm-search-select-trigger is-readonly">
          <span class="vm-search-select-trigger-label">{{ selectedVcpuLabel }}</span>
          <span class="caret"></span>
        </button>
      </template>
    </td>
  </tr>

  <template v-if="showAdvanced">
    <tr>
      <th>BIOS</th>
      <td>
        <template v-if="editableState">
          <OsTypeSelect
            input-name="vm[bios_id]"
            :options="biosOptions"
            :model-value="currentValue('bios', initialBios)"
            empty-label="Select BIOS"
            filter-placeholder="Filter BIOS types"
            @update:modelValue="emit('update:bios', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[bios_id]" type="hidden" :value="initialBios">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedBiosLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>Boot From</th>
      <td>
        <template v-if="editableState">
          <OsTypeSelect
            input-name="vm[bootdev]"
            :options="bootOptions"
            :model-value="currentValue('boot', initialBoot)"
            empty-label="Select boot device"
            filter-placeholder="Filter boot devices"
            @update:modelValue="emit('update:boot', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[bootdev]" type="hidden" :value="initialBoot">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedBootLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>Disk Bus</th>
      <td>
        <template v-if="editableState">
          <OsTypeSelect
            input-name="vm[hddtype]"
            :options="hddtypeOptions"
            :model-value="currentValue('hddtype', initialHddtype)"
            empty-label="Select disk bus"
            filter-placeholder="Filter disk bus types"
            @update:modelValue="emit('update:hddtype', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[hddtype]" type="hidden" :value="initialHddtype">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedHddtypeLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>Disk Image</th>
      <td>
        <template v-if="editableDiskImage">
          <OsTypeSelect
            input-name="vm[hdd_file]"
            :options="diskImageOptions"
            :model-value="currentValue('diskImage', initialDiskImage)"
            empty-label="Select a disk image"
            filter-placeholder="Filter disk images"
            @update:modelValue="emit('update:diskImage', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[hdd_file]" type="hidden" :value="initialDiskImage">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedDiskImageLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>OS Type</th>
      <td>
        <template v-if="editableState">
          <OsTypeSelect
            input-name="vm[os]"
            :options="osOptions"
            :model-value="currentValue('os', initialOs)"
            empty-label="Select OS type"
            filter-placeholder="Filter OS types"
            @update:modelValue="emit('update:os', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[os]" type="hidden" :value="initialOs">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedOsLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>Console</th>
      <td>
        <template v-if="editableState">
          <OsTypeSelect
            input-name="vm[console_type]"
            :options="consoleTypeOptions"
            :model-value="currentValue('consoleType', initialConsoleType)"
            empty-label="Select console type"
            filter-placeholder="Filter console types"
            @update:modelValue="emit('update:consoleType', $event)"
          />
        </template>
        <template v-else>
          <input name="vm[console_type]" type="hidden" :value="initialConsoleType">
          <button type="button" class="form-control vm-search-select-trigger is-readonly">
            <span class="vm-search-select-trigger-label">{{ selectedConsoleTypeLabel }}</span>
            <span class="caret"></span>
          </button>
        </template>
      </td>
    </tr>

    <tr>
      <th>ISO Image</th>
      <td>
        <OsTypeSelect
          input-name="vm[cdrom_file]"
          :options="isoOptions"
          :model-value="currentValue('iso', initialIso)"
          empty-label="Select an ISO image"
          filter-placeholder="Filter ISO images"
          @update:modelValue="emit('update:iso', $event)"
        />
      </td>
    </tr>
  </template>

  <tr v-if="showOwner">
    <th>Owner</th>
    <td>
      <template v-if="editableOwner">
        <OsTypeSelect
          input-name="vm[user_id]"
          :options="ownerOptions"
          :model-value="currentValue('owner', initialOwner)"
          empty-label="Select owner"
          filter-placeholder="Filter users"
          @update:modelValue="emit('update:owner', $event)"
        />
      </template>
      <template v-else>
        <input name="vm[user_id]" type="hidden" :value="initialOwner">
        <button type="button" class="form-control vm-search-select-trigger is-readonly">
          <span class="vm-search-select-trigger-label">{{ selectedOwnerLabel }}</span>
          <span class="caret"></span>
        </button>
      </template>
    </td>
  </tr>
</template>

<script setup>
import { computed } from "vue"
import OsTypeSelect from "./OsTypeSelect.vue"

const props = defineProps({
  editableState: {
    type: Boolean,
    default: false
  },
  showAdvanced: {
    type: Boolean,
    default: false
  },
  showOwner: {
    type: Boolean,
    default: false
  },
  editableDiskImage: {
    type: Boolean,
    default: false
  },
  editableOwner: {
    type: Boolean,
    default: false
  },
  vcpuOptions: {
    type: Array,
    default: () => []
  },
  biosOptions: {
    type: Array,
    default: () => []
  },
  bootOptions: {
    type: Array,
    default: () => []
  },
  hddtypeOptions: {
    type: Array,
    default: () => []
  },
  diskImageOptions: {
    type: Array,
    default: () => []
  },
  osOptions: {
    type: Array,
    default: () => []
  },
  consoleTypeOptions: {
    type: Array,
    default: () => []
  },
  isoOptions: {
    type: Array,
    default: () => []
  },
  ownerOptions: {
    type: Array,
    default: () => []
  },
  initialVcpu: {
    type: [String, Number],
    default: ""
  },
  initialBios: {
    type: [String, Number],
    default: ""
  },
  initialBoot: {
    type: [String, Number],
    default: ""
  },
  initialHddtype: {
    type: [String, Number],
    default: ""
  },
  initialDiskImage: {
    type: [String, Number],
    default: ""
  },
  initialOs: {
    type: [String, Number],
    default: ""
  },
  initialConsoleType: {
    type: [String, Number],
    default: "vnc"
  },
  initialIso: {
    type: [String, Number],
    default: ""
  },
  initialOwner: {
    type: [String, Number],
    default: ""
  },
  values: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits([
  "update:vcpu",
  "update:bios",
  "update:boot",
  "update:hddtype",
  "update:diskImage",
  "update:os",
  "update:consoleType",
  "update:iso",
  "update:owner"
])

function selectedLabel(options, value, fallback = "N/A") {
  return (options || []).find((option) => String(option.value) === String(value))?.label || fallback
}

function currentValue(key, fallback) {
  if (props.values && Object.prototype.hasOwnProperty.call(props.values, key)) {
    return props.values[key]
  }

  return fallback
}

const selectedVcpuLabel = computed(() => selectedLabel(props.vcpuOptions, currentValue("vcpu", props.initialVcpu)))
const selectedBiosLabel = computed(() => selectedLabel(props.biosOptions, currentValue("bios", props.initialBios)))
const selectedBootLabel = computed(() => selectedLabel(props.bootOptions, currentValue("boot", props.initialBoot)))
const selectedHddtypeLabel = computed(() => selectedLabel(props.hddtypeOptions, currentValue("hddtype", props.initialHddtype)))
const selectedDiskImageLabel = computed(() => selectedLabel(props.diskImageOptions, currentValue("diskImage", props.initialDiskImage)))
const selectedOsLabel = computed(() => selectedLabel(props.osOptions, currentValue("os", props.initialOs)))
const selectedConsoleTypeLabel = computed(() => selectedLabel(props.consoleTypeOptions, currentValue("consoleType", props.initialConsoleType)))
const selectedOwnerLabel = computed(() => selectedLabel(props.ownerOptions, currentValue("owner", props.initialOwner)))
</script>
